{
    "table": {
        "paging": {
            "showAll": "Todos",
            "rowsPerPage": "Filas por página",
            "info": "Filas %{from} a %{to} (%{count} elementos)"
        },
        "no_data": "Sin datos",
        "loading_data": "Cargando...",
        "empty": {
            "filtered": "Nada coincide con tu búsqueda o filtros",
            "alerts": "Aún no hay alertas",
            "api": "Aún no hay claves de API",
            "archives": "Aún no hay archivos",
            "calibrations": "Aún no hay calibraciones",
            "certificates": "Aún no hay certificados",
            "invitations": "No hay invitaciones pendientes",
            "organizations": "Aún no hay organizaciones",
            "partnerships": "Aún no hay asociaciones",
            "reports": "Aún no hay informes",
            "users": "Aún no hay usuarios",
            "webhooks": "Aún no hay webhooks",
            "webhooks_hint": "Los webhooks envían datos de dispositivos y notificaciones de alertas a tus propios sistemas.",
            "devices": "Aún no hay dispositivos",
            "devices_hint": "Reclama un dispositivo y aparecerá aquí.",
            "api_hint": "Las claves de API permiten que tus propias aplicaciones lean los datos de tu organización."
        }
    }
}
